import React, { Fragment, useState, useEffect, useContext, useRef } from "react";

// context
import { DispatchContext } from "bodycodi/cmap/app/components/common/context";

// assets
import down from "bodycodi/cmap/app/img/down.png";
import up from "bodycodi/cmap/app/img/up.png";
import right from "bodycodi/cmap/app/svg/icon_right_arrow_gray.svg";
import icon_question_small from "bodycodi/cmap/app/svg/icon_question_small.svg";

// utils
import {
  getServiceType,
  getUseNumber,
  getUsePeriod,
  moneyFormatter,
} from "bodycodi/cmap/app/js/common";
import PassUsableBranchList from "../../common/PassUsableBranchList";

const ServiceDetails = ({ service }: any) => {
  const { dispatch } = useContext(DispatchContext);
  const [open, setOpen] = useState(false);
  const [branchListOpen, setBranchListOpen] = useState(false);
  const wrapRef: any = useRef(null);
  const inBoxRef: any = useRef(null);
  const remainDayLimit = service.dayLimit - service.dayScheduleCnt;
  const remainWeekLimit = service.weekLimit - service.weekScheduleCnt;
  const remainMaxBookingNumber = service.maxBookingNumber - service.reservationScheduleCnt;

  useEffect(() => {
    if (open) {
      const height = inBoxRef.current.offsetHeight;
      wrapRef.current.style.height = height + "px";
    } else {
      wrapRef.current.style.height = 0;
    }
  }, [open]);

  const handleOpenInfo = (type: string) => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "PASS_CARD_INFO_POP",
      open: { passCardInfoPop: true },
    });

    dispatch({
      type: "UPDATE",
      data: { passCardInfoType: type },
    });
  };

  return (
    <Fragment>
      <div className="service">
        <div className="header padding">
          <span className="title">{service?.serviceName}</span>
          {service?.serviceType === "APPOINTMENT" && (
            <span className="time-badge">{service?.serviceTime}분</span>
          )}
        </div>

        <div className="info">
          <span className="price">{moneyFormatter(service?.price)}</span>
          <span className="additional-info middot">{getServiceType(service?.serviceType)}</span>
          <span className="additional-info middot">{getUsePeriod(service)}</span>
          <span className="additional-info middot">{getUseNumber(service)}</span>
        </div>

        <div className={"fold-wrap"} ref={wrapRef}>
          <div className="fold" ref={inBoxRef}>
            <div className="wrapper">
              <span className="key">주간 이용</span>
              <div className="value">
                {service.weekLimit * 1 === -1 && <span className="bold blue">무제한</span>}
                {service.weekLimit * 1 !== -1 && (
                  <Fragment>
                    <span className="blue">
                      {remainWeekLimit} {service.weekLimitDayFlag === "D" ? "일" : "회"} 남음
                    </span>
                    <span className="gray"> | </span>
                    <span className="black">
                      주 {service.weekLimit} {service.weekLimitDayFlag === "D" ? "일" : "회"}
                    </span>
                  </Fragment>
                )}
              </div>
            </div>

            <div className="wrapper">
              <span className="key">1일 이용</span>
              <div className="value">
                {service.dayLimit * 1 === -1 && <span className="bold blue">무제한</span>}
                {service.dayLimit * 1 !== -1 && (
                  <Fragment>
                    <span className="blue">{remainDayLimit}회 남음</span>
                    <span className="gray"> | </span>
                    <span className="black">주 {service.dayLimit}회</span>
                  </Fragment>
                )}
              </div>
            </div>

            <div className="wrapper">
              <span className="key">
                최대 예약권
                <img
                  src={icon_question_small}
                  alt=""
                  onClick={() => handleOpenInfo("maxBooking")}
                />
              </span>
              <div className="value">
                {service.maxBookingNumber * 1 === -1 && <span className="bold blue">무제한</span>}
                {service.maxBookingNumber * 1 !== -1 && (
                  <Fragment>
                    <span className="blue">{remainMaxBookingNumber}회 남음</span>
                    <span className="gray"> | </span>
                    <span className="black">주 {service.maxBookingNumber}회</span>
                  </Fragment>
                )}
              </div>
            </div>

            <div className="wrapper">
              <span className="key">
                예약 취소권
                <img src={icon_question_small} alt="" onClick={() => handleOpenInfo("cancel")} />
              </span>
              <div className="value">
                {service.cancelNumber * 1 === -1 && <span className="bold blue">무제한</span>}
                {service.cancelNumber * 1 !== -1 && (
                  <Fragment>
                    <span className="blue">{service.remainCancelNumber}회 남음</span>
                    <span className="gray"> | </span>
                    <span className="black">주 {service.cancelNumber}회</span>
                  </Fragment>
                )}
              </div>
            </div>

            {service.forceCancelNumber !== 0 && (
              <div className="wrapper">
                <span className="key">
                  특별 취소권
                  <img
                    src={icon_question_small}
                    alt=""
                    onClick={() => handleOpenInfo("forceCancel")}
                  />
                </span>
                <div className="value">
                  {service.forceCancelNumber * 1 === -1 && (
                    <span className="bold blue">무제한</span>
                  )}
                  {service.forceCancelNumber * 1 !== -1 && (
                    <Fragment>
                      <span className="blue">{service.remainForceCancelNumber}회 남음</span>
                      <span className="gray"> | </span>
                      <span className="black">주 {service.forceCancelNumber}회</span>
                    </Fragment>
                  )}
                </div>
              </div>
            )}

            {service?.usableBranch.length ? (
              <div className="branch" onClick={() => setBranchListOpen(true)}>
                <span className="key">이용 가능한 지점</span>
                <span className="black">
                  {service?.usableBranch.length}개 지점
                  <img src={right} />
                </span>
              </div>
            ) : null}
          </div>
        </div>

        <div className="more-container">
          <span className="button" onClick={() => setOpen(!open)}>
            {open && (
              <Fragment>
                접기
                <img src={up} />
              </Fragment>
            )}
            {!open && (
              <Fragment>
                더보기
                <img src={down} />
              </Fragment>
            )}
          </span>
        </div>
      </div>

      {service.serviceType.toLowerCase() === "appointment" && (
        <>
          <div className="appointment-info">
            <span className="gray">담당강사</span>
            <span className="dark">{service?.coachName}</span>
          </div>
          <div className="appointment-info">
            <span className="gray">장소</span>
            <span className="dark">{service?.spaceName}</span>
          </div>
        </>
      )}

      <PassUsableBranchList
        open={branchListOpen}
        setOpen={setBranchListOpen}
        list={service.usableBranch}
      />
    </Fragment>
  );
};

export default ServiceDetails;
